export default {"src":"/_next/static/media/pharmacy-self-prescription.668223d1.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};